const selectors = {
  link: '[data-header-account-link]',
  name: '[data-header-account-name]',
  points: '[data-header-account-points]',
};

export default class HeaderAccountLink {
  constructor(root) {
    this.el = root.querySelector(selectors.link);

    if (!this.el) return;

    this.nameEl = this.el.querySelector(selectors.name);
    this.pointsEl = this.el.querySelector(selectors.points);
    this.fallbackName = this.nameEl?.textContent?.trim() || '';

    if (window.Smile?.customer?.current?.()) {
      this._handleSmileReady();
    } else {
      document.addEventListener(
        'smile-js-initialized',
        this._handleSmileReady,
        { once: true },
      );
    }
  }

  _handleSmileReady = async () => {
    const { Smile } = window;

    if (!Smile) return;

    const customer = Smile.customer.current();

    if (!customer) return;

    if (this.nameEl) {
      const name = customer.firstName || this.fallbackName;

      this.nameEl.textContent = name;
    }

    await this._updatePoints(Smile);
  };

  _updatePoints = async Smile => {
    if (!this.pointsEl) return;

    try {
      if (
        !Smile.customerPointsWallet.preloaded() ||
        !Smile.pointsSettings.preloaded()
      ) {
        await Smile.preload(['customerPointsWallet', 'pointsSettings']);
      }

      const wallet = Smile.customerPointsWallet.preloaded();
      const balance =
        typeof wallet === 'number'
          ? wallet
          : (wallet?.balance ?? wallet?.pointsBalance);

      if (balance == null) return;

      const formattedPoints = Smile.formatPoints(balance, {
        showPointsLabel: false,
      });

      this.pointsEl.textContent = `${formattedPoints} XP`;
    } catch {
      // Keep the placeholder if Smile data is unavailable.
    }
  };

  destroy() {
    document.removeEventListener(
      'smile-js-initialized',
      this._handleSmileReady,
    );
  }
}
